import { MenuItemData } from '@components/Navigation';
import { mc, StyleProps } from '@styles';
import React, { FC, MouseEventHandler } from 'react';

import ChevronDownIcon from './assets/chevronDown.inline.svg';

interface Props extends StyleProps {
  item: MenuItemData;
  active?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  onMouseEnter?: MouseEventHandler<HTMLAnchorElement>;
  onMouseLeave?: MouseEventHandler<HTMLAnchorElement>;
}

export const NavigationBarBtn: FC<Props> = ({ className, style, item, active, onClick, onMouseEnter, onMouseLeave }) => {
  const { title, subtitle, url = '#' } = item;
  return (
    <a
      href={url}
      className={mc('flex-col justify-center items-star', 'pr-2 xl:pr-8 pl-2 pt-2', 'hover:bg-light-gray', className)}
      style={style}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span
        className={mc(
          'flex flex-row items-center',
          'font-sharpsans leading-normal font-bold text-ocean-blue uppercase',
          'text-xs xl:text-sm',
        )}
      >
        <span className="block">{title}</span>
        {!!item.items && (
          <span className="block ml-3.5">
            <ChevronDownIcon className={mc(active && 'rotate-180')} />
          </span>
        )}
      </span>
      {!!subtitle && (
        <span className={mc('block', 'text-xs font-raleway leading-normal font-medium text-ocean-blue')}>{subtitle}</span>
      )}
    </a>
  );
};

export type NavigationBarBtnProps = Props;
export default NavigationBarBtn;
